module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="filter-menu dropdown-toggle" id="cidAction' +
((__t = (data.cid)) == null ? '' : __t) +
'" data-toggle="dropdown" role="button">\n    <div class="queryable" ' +
((__t = ( data.header.title ? 'title="' + data.header.title + '" data-toggle="tooltip"' : '')) == null ? '' : __t) +
'>\n        ' +
((__t = ( data.name )) == null ? '' : __t) +
'\n        ';
 if (data.sortOptions && data.sortOptions.active && data.sortOptions.active === "-1") { ;
__p += '\n        <i class="fas fa-sort-down"></i>\n        ';
 } else if (data.sortOptions && data.sortOptions.active && data.sortOptions.active === "1") { ;
__p += '\n        <i class="fas fa-sort-up"></i>\n        ';
 } else { ;
__p += '\n        <i class="fas fa-sort"></i>\n        ';
 } ;
__p += '\n        <i class="far fa-filter filter-menu-icon"></i>\n    </div>\n</div>\n\n<ul id="cidMenu' +
((__t = (data.cid)) == null ? '' : __t) +
'" class="dropdown-menu pz-dropdown pz-queryable" role="menu" aria-labelledby="cidAction' +
((__t = (data.cid)) == null ? '' : __t) +
'">\n    <li role="presentation"><span class="sort-filter-label"> ' +
((__t = ( strings.common.sort.name )) == null ? '' : __t) +
' </span></li>\n    <li role="presentation">\n        <a href="#" class="sortable-ascending ' +
((__t = ( (data.sortOptions && data.sortOptions.active && data.sortOptions.active === '1') ? 'active' : '')) == null ? '' : __t) +
'">\n            <i class="far fa-sort-alpha-up"></i> ' +
((__t = ( strings.common.sort.by[data.ordering].ascending )) == null ? '' : __t) +
'\n        </a>\n    </li>\n    <li role="presentation">\n        <a href="#" class="sortable-descending ' +
((__t = ( (data.sortOptions && data.sortOptions.active && data.sortOptions.active === '-1') ? 'active' : '')) == null ? '' : __t) +
'">\n            <i class="far fa-sort-alpha-down"></i> ' +
((__t = ( strings.common.sort.by[data.ordering].descending )) == null ? '' : __t) +
'\n        </a>\n    </li>\n    <div class="pz-border"></div>\n    <li role="presentation" class="queryable-filters"><span class="sort-filter-label">' +
((__t = ( strings.common.filter.select )) == null ? '' : __t) +
'</span></li>\n    <div class="async-template"></div>\n</ul>\n';
return __p
}